export default __webpack_public_path__ + "static/media/black-arrow.9b83b9a8.svg";